import TradingOfferDetail from 'modules/trading/pages/TradingOfferDetail';
import { TradingOfferDetailProvider } from '../pages/TradingOfferDetail/context/TradingOfferDetailContext';

const TradingOfferDetailContainer = () => (
  <TradingOfferDetailProvider>
    <TradingOfferDetail />
  </TradingOfferDetailProvider>
);

export default TradingOfferDetailContainer;
